<template>
  <div class="app-main-layout" id="page">
    <div class="mediaIndicator"></div>
    <ToastMsg />
    <PageTopbar @toggle-sidebar="toggleSidebar" />
    <div class="container">
      <PageSidebar :is-open="isSidebarOpen" @toggle-sidebar="toggleSidebar" />
      <router-view />
    </div>
    <PageFooter />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import PageTopbar from "@/components/app/PageTopbar.vue";
import PageSidebar from "@/components/app/PageSidebar.vue";
import PageFooter from "@/components/app/PageFooter.vue";
import ToastMsg from "@/components/app/ToastMsg.vue";

// determine current window width
const isSidebarOpen = ref(window.innerWidth >= 768);

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};
</script>